// Back4App Configuration
// Values come from the build's env only (client/.env locally, Docker build args in CI); a build
// without them fails (see back4appBuildEnv.ts). The per-branch fallback literals that used to
// pick staging's or production's app are gone. [SC-414]

export const BACK4APP_CONFIG = {
    applicationId: import.meta.env.VITE_BACK4APP_APPLICATION_ID || '',
    javascriptKey: import.meta.env.VITE_BACK4APP_JAVASCRIPT_KEY || '',
    // Back4App's API host, the same for every app; not a key.
    serverURL: import.meta.env.VITE_BACK4APP_SERVER_URL || 'https://parseapi.back4app.com',
    liveQueryServerURL: import.meta.env.VITE_BACK4APP_LIVE_QUERY_URL || '',

    // App info
    appName: import.meta.env.VITE_APP_NAME || 'Sevv',

    // No masterKey / restKey here. They used to sit in this object behind a comment claiming
    // "server-side only - not exposed to client", which was false: this file is imported by
    // services/initializeParse.ts and runs in the browser. Worse, they were spelled
    // `import.meta.env.BACK4APP_MASTER_KEY` — Vite only substitutes VITE_-prefixed variables
    // and this project sets no envPrefix, so the value was always `undefined` and the
    // hardcoded fallback literal was compiled into the bundle in every environment. Both keys
    // were verified present in the built dist/assets/js/*.js, not just the source map.
    //
    // A Parse master key bypasses every ACL and CLP, so this granted full read/write on every
    // class to anyone who opened the app. Nothing in client/ ever read either field
    // (useLiveQueryV2 explicitly passes `masterKey: undefined`). Any key that shipped in a
    // built bundle must be treated as compromised and rotated in the Back4App dashboard. If a
    // privileged operation is needed from the browser, route it through a server endpoint.
    // [SC-208]
}

// Validate configuration
if (!BACK4APP_CONFIG.applicationId || !BACK4APP_CONFIG.javascriptKey || !BACK4APP_CONFIG.liveQueryServerURL) {
    console.error('Back4App configuration is missing required values. Please check your environment variables.')
}

export default BACK4APP_CONFIG 